module.exports = __webpack_public_path__ + "img/planet_hover.47906908.png";